var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterGroup_1;
/* eslint-disable import/no-duplicates */
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './filter'; // force import for JsonSchemaV2
import { Filter, FilterType } from './filter';
import { filterGroupSchemaValidation } from '../../validations.generated';
export var FilterGroupOp;
(function (FilterGroupOp) {
    FilterGroupOp["AND"] = "and";
    FilterGroupOp["OR"] = "or";
})(FilterGroupOp || (FilterGroupOp = {}));
export const filterGroupSchema = {
    $id: 'urn:wisepipe-common-pipe:FilterGroup',
    type: 'object',
    properties: {
        op: { type: 'string', pattern: 'and|or' },
        filters: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:Filter' },
            uniqueItems: true
        }
    },
    required: ['op', 'filters']
};
let FilterGroup = FilterGroup_1 = class FilterGroup extends Filter {
    constructor(op, filters) {
        super(FilterType.GROUP);
        this.op = op;
        this.filters = filters ?? [];
        JSON.validate(this, FilterGroup_1);
    }
    isValid(parameters, source) {
        return this.filters.every((f) => f.isValid(parameters, source));
    }
    getColumnArguments(parameters) {
        const uniqueCols = new Set();
        this.filters.forEach((f) => f.getColumnArguments(parameters).forEach((col) => uniqueCols.add(col)));
        return uniqueCols;
    }
    applyParameters(parameters) {
        return new FilterGroup_1(this.op, this.filters.map((f) => f.applyParameters(parameters)));
    }
    getBaseValues(parameters) {
        return {
            op: this.op,
            filters: this.filters.map((f) => f.getBaseValues(parameters))
        };
    }
};
FilterGroup = FilterGroup_1 = __decorate([
    JsonSchemaV2(filterGroupSchema, filterGroupSchemaValidation),
    JsonDiscriminatorValue(FilterType.GROUP)
], FilterGroup);
export { FilterGroup };
//# sourceMappingURL=filterGroup.js.map